import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ParameterState {
  parameter: Parameter | null;
  setParameter: (newParameter: Partial<Parameter>) => void;
  resetParameter: () => void;
}

const initialParameterState: Parameter = {
  id: "",
  type: "",
  value: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useParameterCreateStore = create<ParameterState>()(
  devtools(
    (set) => ({
      parameter: initialParameterState,
      setParameter: (newParameter) =>
        set((state) => ({
          parameter: { ...state.parameter, ...newParameter } as Parameter,
        })),
      resetParameter: () => set({ parameter: initialParameterState }),
    }),
    { name: "ParameterSelected" }
  )
);
